export default __webpack_public_path__ + "static/media/spinner_background.0328bdb8.svg";